export default {
  data() {
    return {
      imageUrl: '' || require('../assets/logo.png')
    }
  },
  methods: {
    handleAvatarSuccess() {

    },
    beforeAvatarUpload() {

    }
  }
}
